// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__OL6Kl","spin":"Spinner_spin__ZtO6B","boldCentered":"Spinner_boldCentered__410G2","buttonSpinner":"Spinner_buttonSpinner__ciCmo"};